import { I18nFormatter } from '../../../../utils/I18n/I18n';
import { createSelector } from 'reselect';
import ReportComponent from '../../../../utils/ReportComponent/ReportComponent';
import { getLastDays } from '../helpers';

const statistics = (state) => state.dashboard.last.data;
const reportUtils = ReportComponent.utils;
const metrics = reportUtils.getKeysMetric(true);

export const getData = createSelector(
    statistics,
    (statisticsData = []) => {
        let metricsData = {};

        getLastDays().reverse().map((keyDay) => {
            let dataDay = statisticsData.find((item) => item.GroupBy === keyDay) || {};

            for (let i = 0; i < metrics.length; i++) {
                let key = metrics[i];
                if (key === 'GroupBy') continue;

                if (!(key in metricsData)) {
                    metricsData[key] = {
                        title: reportUtils.getTitleChain(key),
                        data: []
                    };
                }

                let value = +dataDay[key] || 0;
                metricsData[key].data.push(value);
            }
        });

        return metricsData;
    }
);

export const getLabelXAxes = createSelector(
    () => {
        let list = [];
        getLastDays().reverse().map((keyDay) => {
            list.push(I18nFormatter.date(keyDay));
        });

        return list;
    }
);
